import {
  createAsyncThunk,
  createSlice,
  injectSlice,
} from '@bonanza-social/toolkit/state';
import { WelcomePromosState } from './welcomePromos.types';
import PromosService from '../services/PromosService';

export const getWelcomePromos = createAsyncThunk(
  'welcomePromos/get',
  async () => {
    const welcomeData = await PromosService.getPromos({
      params: { isBanner: true },
    });

    return welcomeData.items.filter(
      (promo) =>
        promo.promoType === 'Welcome' || promo.promoType === 'Referral',
    );
  },
);

const initialState: WelcomePromosState = {
  data: [],
  dataState: 'idle',
};

const welcomePromos = createSlice({
  name: 'welcomePromos',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWelcomePromos.pending, (state) => {
      state.dataState = 'pending';
    });

    builder.addCase(getWelcomePromos.fulfilled, (state, { payload }) => {
      state.dataState = 'fulfilled';
      state.data = payload;
    });

    builder.addCase(getWelcomePromos.rejected, (state) => {
      state.dataState = 'rejected';
    });
  },
});

const withWelcomePromos = injectSlice({
  reducerPath: 'welcomePromos',
  reducer: welcomePromos.reducer,
});

export const selectWelcomePromos = withWelcomePromos.selector(
  (state) => state.welcomePromos.data,
);

export const selectWelcomePromosState = withWelcomePromos.selector(
  (state) => state.welcomePromos.dataState,
);

declare global {
  interface LazyLoadedSlices {
    welcomePromos: ReturnType<typeof welcomePromos.reducer>;
  }
}
